import script from "./TableContractors.vue?vue&type=script&setup=true&lang=js"
export * from "./TableContractors.vue?vue&type=script&setup=true&lang=js"

import "./TableContractors.vue?vue&type=style&index=0&id=e1ea2eb8&lang=css"

const __exports__ = script;

export default __exports__